import { Injectable } from '@angular/core';
import { ActivitiesAggrigatorModel } from '@shared/model/activities-aggrigator-model';
import { ActivityVerbEnum } from '@shared/model/enum/activity-verb-enum';
import { ObjectTypeEnum } from '@shared/model/enum/object-type-enum';
import { INotifTextStrategy } from '../model/notification.model';

@Injectable({
  providedIn: 'root'
})
export class LikeNotifStrategy implements INotifTextStrategy {

  public createText(activity: ActivitiesAggrigatorModel, receiver: string, isFireBaseContext: boolean): string {
    const actorName = isFireBaseContext ? (activity?.actor?.fullName ?? '') : '';
    const verb = activity?.verb;

    switch (verb) {
      case ActivityVerbEnum.Reacted:
        return `${actorName} نظر شما را پسندید.`;

      case ActivityVerbEnum.Liked:
        return isFireBaseContext
          ? this.buildFirebaseText(activity)
          : this.buildTemplateText(activity);

      default:
        return '';
    }

  }


  // ---------- Firebase Context ----------
  private buildFirebaseText(activity: ActivitiesAggrigatorModel): string {
    const actorName = activity?.actor?.fullName ?? '';
    return this.composeLikeMessage(activity, actorName);
  }

  // ---------- Template Context ----------
  private buildTemplateText(activity: ActivitiesAggrigatorModel): string {
    const isPlural = (activity?.totalLikes ?? 0) > 1;
    const likedText = isPlural ? 'پسندیدند' : 'پسندید';
    const congratsText = isPlural ? 'تبریک گفتند' : 'تبریک گفت';

    return this.composeLikeMessage(activity, '', likedText, congratsText);
  }


  // ---------- Helpers ----------
  private composeLikeMessage(activity: ActivitiesAggrigatorModel, actorName: string, likedText = 'پسندید', congratsText = 'تبریک گفت'): string {
    const objectType = activity?.inDirectObject?.objectType;
    const data = activity?.inDirectObject?.data;

    switch (objectType) {
      case ObjectTypeEnum.Review:
        return this.getReviewLikeText(actorName, data, likedText);

      case ObjectTypeEnum.Quote:
        return `${actorName} بریدۀ کتاب شما را ${likedText}.`;

      case ObjectTypeEnum.Progress:
        return this.getProgressLikeText(actorName, activity, likedText);

      case ObjectTypeEnum.Post:
        return `${actorName} پست شما را ${likedText}.`;

      case ObjectTypeEnum.Booklist:
        return `${actorName} لیست شما را ${likedText}.`;

      case ObjectTypeEnum.Club:
        return `${actorName} شروع به کار باشگاه شما را ${likedText}.`;

      case ObjectTypeEnum.UserChallenge:
        return this.getUserChallengeLikeText(actorName, data, likedText, congratsText);

      case ObjectTypeEnum.badge:
        return `${actorName} کسب این دستاورد را ${congratsText}.`;

      case ObjectTypeEnum.UserReportPublished:
        return `${actorName} گزارش سالیانه‌ی شما را ${likedText}.`;

      default:
        return `${actorName} پسندید.`;
    }
  }

  private getReviewLikeText(actorName: string, data: any, likedText: string): string {
    const hasBody = data?.body || data?.body?.length === 0;
    const hasRate = data?.rate > 0;
    return !hasBody && hasRate ? `${actorName} امتیاز شما را ${likedText}.` : `${actorName} یادداشت شما را ${likedText}.`;
  }

  private getProgressLikeText(actorName: string, activity: ActivitiesAggrigatorModel, likedText: string): string {
    const steps = activity.inDirectObject?.data?.steps;
    const totalPages = activity?.inDirectObject?.data?.totalPages;

    if (steps === -1) {
      return `${actorName} تصمیم به خواندن این کتاب را ${likedText}.`;
    }

    if (steps === totalPages) {
      return `${actorName} تمام کردن این کتاب را ${likedText}.`;
    }

    if (steps > 0 && steps < totalPages) {
      return `${actorName} گزارش مطالعه شما را ${likedText}.`;
    }

    return `${actorName} شروع کردن این کتاب را ${likedText}.`;
  }

  private getUserChallengeLikeText(actorName: string, data: any, likedText: string, congratsText: string): string {
    const isCompleted = data?.totalStep === data?.currentStep;
    const txt = isCompleted
      ? `به پایان رساندن چالش را به شما ${congratsText}.`
      : `پیوستن شما به چالش را ${likedText}.`;
    return `${actorName} ${txt}`;
  }

}

